<section class="grid" role="region">
	<!-- Column 1: Personal Data -->
	<section class="column" aria-labelledby="personal-data-heading">
		<h3 id="personal-data-heading">
			<mat-icon class="material-symbols-outlined" aria-hidden="true">person</mat-icon>
			<span>{{ 'base.field.group.personal_data' | transloco }}</span>
		</h3>

		<section class="info-row">
			<section class="name-column">
				<strong>{{ user().firstName }}</strong>
				<strong>{{ user().lastName }}</strong>
			</section>
			<section class="data-column">
				<p [attr.aria-label]="'base.field.gender' | transloco">{{ userGender() }}</p>
			</section>
		</section>

		<h3 id="address-heading">
			<mat-icon class="material-symbols-outlined" aria-hidden="true">home_pin</mat-icon>
			<span>{{ 'base.field.group.address' | transloco }}</span>
		</h3>

		<address aria-labelledby="address-heading">
			<p [attr.aria-label]="'base.field.street_address' | transloco">
				{{ user().streetAddress || '-' }}
			</p>
			<p [attr.aria-label]="'base.field.postal_code_and_city' | transloco">{{ user().postalCode }} {{ user().city }}</p>
		</address>
	</section>

	<!-- Column 2: Communication -->
	<section class="column" aria-labelledby="communication-heading">
		<h3 id="communication-heading">
			<mat-icon class="material-symbols-outlined" aria-hidden="true">phone_in_talk</mat-icon>
			<span>{{ 'institution.details.communication' | transloco }}</span>
		</h3>

		<section class="communication" aria-labelledby="communication-heading">
			<p class="label">{{ 'institution.details.preferred_communication' | transloco }}</p>

			<p [attr.aria-label]="'base.field.email' | transloco">
				<a [href]="'mailto:' + user().email">
					{{ user().email }}
				</a>
			</p>
			<p [attr.aria-label]="'base.field.remark' | transloco">
				{{ user().notesOnAccessability || '-' }}
			</p>

			@if (preferredCommunicationWay()) {
				@if (preferredCommunicationWay()!.categoryContactPointId === 1) {
					<p>
						<a [href]="'tel:' + preferredCommunicationWay()!.contactValue">
							{{ preferredCommunicationWay()!.contactValue }}
						</a>
					</p>
				} @else if (preferredCommunicationWay()!.categoryContactPointId === 2) {
					<p>
						<a [href]="'mailto:' + preferredCommunicationWay()!.contactValue">
							{{ preferredCommunicationWay()!.contactValue }}
						</a>
					</p>
				}
				<p>{{ preferredCommunicationWay()!.remark }}</p>
			}

			<!-- Additional communication ways -->
			@if (communicationWays().length >= 1) {
				<cdk-accordion lvrPadding [padHorizontal]="0" [padVertical]="0">
					<cdk-accordion-item #accordionItem="cdkAccordionItem">
						<button
							matButton
							class="trailing-icon-button"
							(click)="accordionItem.toggle()"
							tabindex="0"
							[attr.id]="'accordion-header-' + user().id"
							[attr.aria-expanded]="accordionItem.expanded"
							[attr.aria-controls]="'accordion-body-' + user().id"
						>
							<span class="label">Weitere Kommunikationswege</span>
							@if (accordionItem.expanded) {
								<mat-icon>keyboard_arrow_up</mat-icon>
							} @else {
								<mat-icon>keyboard_arrow_down</mat-icon>
							}
						</button>

						@if (accordionItem.expanded) {
							<section
								role="region"
								class="accordion-content"
								[style.display]="accordionItem.expanded ? '' : 'none'"
								[attr.id]="'accordion-body-' + user().id"
								[attr.aria-labelledby]="'accordion-header-' + user().id"
							>
								@for (cp of communicationWays()!; track cp.id) {
									<div lvrBorder borderPosition="bottom" lvrPadding [padHorizontal]="8" [padVertical]="0">
										@if (cp.categoryContactPointId === 1) {
											<p>
												<a [href]="'tel:' + cp.contactValue">{{ cp.contactValue }}</a>
											</p>
										} @else if (cp.categoryContactPointId === 2) {
											<p>
												<a [href]="'mailto:' + cp.contactValue">{{ cp.contactValue }}</a>
											</p>
										}
										<p style="margin-top: 16px">{{ cp.remark }}</p>
									</div>
								}
							</section>
						}
					</cdk-accordion-item>
				</cdk-accordion>
			}
		</section>
	</section>

	<!-- Column 3: Employment -->
	<section class="column" aria-labelledby="employment-heading">
		<h3 id="employment-heading">
			<mat-icon class="material-symbols-outlined" aria-hidden="true">work</mat-icon>
			<span>{{ 'user.create_user.employment_info' | transloco }}</span>
		</h3>
		<table>
			<tr>
				<th scope="row">{{ 'base.field.serviceOffice' | transloco }}</th>
				<td>{{ user().integrationServiceOffice?.remark }}</td>
			</tr>
			<tr>
				<th scope="row">{{ 'base.field.role' | transloco }}</th>
				<td>{{ user().roles?.shortName }}</td>
			</tr>
			@if (canReadPositionShareDetails()) {
				<tr>
					<th scope="row">{{ 'base.field.service' | transloco }}</th>
					<td>{{ user().service?.name || '-' }}</td>
				</tr>
				<tr>
					<th scope="row">{{ 'base.field.employment' | transloco }}</th>
					<td>
						{{ user().employment?.remark || '-' }}
					</td>
				</tr>
				<tr>
					<th scope="row">{{ 'base.field.positionShare' | transloco }}</th>
					<td>
						{{ user().positionShare?.share ?? '-' }}
					</td>
				</tr>
			}
		</table>
	</section>
</section>
